module.exports = __webpack_public_path__ + "img/Lifestyle_1-print 1.57056b64.png";